<template>
    <div class="zuke_index">
        <div class="head_box">
            <div class="head_top_box">
                <div class="head_top">
                    <a href="javascript:history.back(-1)"><img src="../../assets/images/left.png" alt=""></a>
                    <div class="seatch">
                        <input type="text" v-model.trim="search" placeholder="请输入您要搜索的词条">
                        <img @click='search_input' src="../../assets/images/search/search_top.png" alt="">
                    </div>
                </div>
                <div class="seatch_btn">
                    <div class="search_btn_list" @click='search_btn(1)' :class='search_index == 1 ? "active" : ""'>小区<p></p>
                    </div>
                    <div class="search_btn_list" @click='search_btn(2)' :class='search_index == 2 ? "active" : ""'>公司<p></p>
                    </div>
                    <div class="search_btn_list" @click='search_btn(3)' :class='search_index == 3 ? "active" : ""'>商圈<p></p>
                    </div>
                    <div class="search_btn_list" @click='search_btn(4)' :class='search_index == 4 ? "active" : ""'>品牌公寓<p></p>
                    </div>
                    <div class="search_btn_list" @click='search_btn(5)' :class='search_index == 5 ? "active" : ""'>写字楼<p></p>
                    </div>
                    <div class="search_btn_list" @click='search_btn(6)' :class='search_index == 6 ? "active" : ""'>商业综合体/商铺<p></p>
                    </div>
                    <div class="search_btn_list" @click='search_btn(7)' :class='search_index == 7 ? "active" : ""'>创业孵化器<p></p>
                    </div>
                    <div class="search_btn_list" @click='search_btn(8)' :class='search_index == 8 ? "active" : ""'>物业公司<p></p>
                    </div>
                    <div class="search_btn_list"></div>
                </div>
            </div>
        </div>


        <!-- 列表 -->
        <div class="list">
            <div class="list_list" v-for="list in listData">
                <router-link :to="{name:'baike_detail',params:{sn:list.sn + '.html'}}">
                    <div class="list_img">
                        <img :src="list.image" alt="">
                    </div>
                    <div class="list_box">
                        <h3 class="list_title">{{list.name}}</h3>
                        <div class="list_i" v-if="list.type == 10001 || list.type == 10004 || list.type == 10005 || list.type == 10006">
                            <div class="list_i_list">
                                <div class="list_i_title">建造年代</div>
                                <div class="list_i_text">{{list.attribute.jianzaoniandai}}</div>
                            </div>
                            <div class="list_i_list">
                                <div class="list_i_title">建造面积</div>
                                <div class="list_i_text">{{list.attribute.jianzhumianji}}</div>
                            </div>
                        </div>
                        <div class="list_i" v-if="list.type == 10002">
                            <div class="list_i_list">
                                <div class="list_i_title">法人</div>
                                <div class="list_i_text">{{list.attribute.faren}}</div>
                            </div>
                            <div class="list_i_list">
                                <div class="list_i_title">成立时间</div>
                                <div class="list_i_text">{{list.attribute.chenglishijian}}</div>
                            </div>
                        </div>
                        <div class="list_i" v-if="list.type == 10003">
                            <div class="list_i_list">
                                <div class="list_i_title">城市</div>
                                <div class="list_i_text">{{list.attribute.chengshi}}</div>
                            </div>
                            <div class="list_i_list">
                                <div class="list_i_title">区县</div>
                                <div class="list_i_text">{{list.attribute.quxian}}</div>
                            </div>
                        </div>
                        <div class="list_i" v-if="list.type == 10007">
                            <div class="list_i_list">
                                <div class="list_i_title">建造年代</div>
                                <div class="list_i_text">{{list.attribute.jianzaoniandai}}年建成</div>
                            </div>
                            <div class="list_i_list">
                                <div class="list_i_title">建造面积</div>
                                <div class="list_i_text">{{list.attribute.jianzhumianji}}㎡</div>
                            </div>
                        </div>
                        <div class="list_i" v-if="list.type == 10008">
                            <div class="list_i_list">
                                <div class="list_i_title">城市</div>
                                <div class="list_i_text">{{list.attribute.chengshi}}</div>
                            </div>
                            <div class="list_i_list">
                                <div class="list_i_title">成立时间</div>
                                <div class="list_i_text">{{list.attribute.chenglishijian}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="hot_xq_bot">
                        <img src="../../assets/images/index/location.png" alt="">
                        <div class="hot_xq_bot_title">{{list.attribute.address}}</div>
                    </div>
                </router-link>
            </div>
            <div class="list_list" v-if="arr.length > 0" v-for="list in arr">
                <router-link :to="{name:'baike_detail',params:{sn:list.sn + '.html'}}">
                    <div class="list_img">
                        <img :src="list.image" alt="">
                    </div>
                    <div class="list_box">
                        <h3 class="list_title">{{list.name}}</h3>
                        <div class="list_i" v-if="list.type == 10001 || list.type == 10004 || list.type == 10005 || list.type == 10006">
                            <div class="list_i_list">
                                <div class="list_i_title">建造年代</div>
                                <div class="list_i_text">{{list.attribute.jianzaoniandai}}</div>
                            </div>
                            <div class="list_i_list">
                                <div class="list_i_title">建造面积</div>
                                <div class="list_i_text">{{list.attribute.jianzhumianji}}</div>
                            </div>
                        </div>
                        <div class="list_i" v-if="list.type == 10002">
                            <div class="list_i_list">
                                <div class="list_i_title">法人</div>
                                <div class="list_i_text">{{list.attribute.faren}}</div>
                            </div>
                            <div class="list_i_list">
                                <div class="list_i_title">成立时间</div>
                                <div class="list_i_text">{{list.attribute.chenglishijian}}</div>
                            </div>
                        </div>
                        <div class="list_i" v-if="list.type == 10003">
                            <div class="list_i_list">
                                <div class="list_i_title">城市</div>
                                <div class="list_i_text">{{list.attribute.chengshi}}</div>
                            </div>
                            <div class="list_i_list">
                                <div class="list_i_title">区县</div>
                                <div class="list_i_text">{{list.attribute.quxian}}</div>
                            </div>
                        </div>
                        <div class="list_i" v-if="list.type == 10007">
                            <div class="list_i_list">
                                <div class="list_i_title">建造年代</div>
                                <div class="list_i_text">{{list.attribute.jianzaoniandai}}年建成</div>
                            </div>
                            <div class="list_i_list">
                                <div class="list_i_title">建造面积</div>
                                <div class="list_i_text">{{list.attribute.jianzhumianji}}㎡</div>
                            </div>
                        </div>
                        <div class="list_i" v-if="list.type == 10008">
                            <div class="list_i_list">
                                <div class="list_i_title">城市</div>
                                <div class="list_i_text">{{list.attribute.chengshi}}</div>
                            </div>
                            <div class="list_i_list">
                                <div class="list_i_title">成立时间</div>
                                <div class="list_i_text">{{list.attribute.chenglishijian}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="hot_xq_bot">
                        <img src="../../assets/images/index/location.png" alt="">
                        <div class="hot_xq_bot_title">{{list.attribute.address}}</div>
                    </div>
                </router-link>
            </div>
            <img v-if="!listData" class="list_no_data" src="../../assets/images/list-no-data-bg.png" alt="">
        </div>
    </div>
</template>

<script>
    export default {
        name: "baike_list",
        data: () => {
            return {
                search_index: 1,
                search: '',
                // 搜索类型
                type: 'xq',
                // 页数
                page: 1,
                arr:[],
                // 搜索类型数组
                typearr: ["xq", "company", "sq", "apartment", "office", "shop", "incubator", "wygs"],
            }
        },
        asyncData({store,route: {params: {type},query: {search}}}) {
            type = type.split('.')
            var arr = ["xq", "company", "sq", "apartment", "office", "shop", "incubator", "wygs"]
            if(type[0] == 'hot'){
                type = '';
            } else {
                for (var i = 0; i < arr.length; i++) {
                    if (type[0] == arr[i]) {
                        type = '1000' + (i + 1)
                    }
                }
            }
            if(!search) {
                search = ""
            }
            return store.dispatch('fetch_baike_list', {type,search})
        },
        computed: {
            listData() {
                if (this.$store.state.baike_list) {
                    if (this.$store.state.baike_list.data) {
                        let data = this.$store.state.baike_list.data
                        var index_num = data[0].type.length - 1;
                        this.search_index = data[0].type.slice(index_num)
                        this.arr = []
                        // console.log(data,this.$store.state)
                        return data;
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
        },
        components: {

        },
        mounted() {
            // 给搜索框赋值
            this.search = this.$route.query.search
            // 给搜索框赋值
            if(this.$route.params.type == 'hot.html'){
                this.type = 'hot'
            }
            // 定义this传入事件内
            var _this = this
            
            var index = this.$route.params.name
            var search = this.$route.query.search
            if (index) {
                this.search_index = index
                this.type = this.typearr[index - 1]
            }
            // 触发请求数据的开关
            var on_off = 0;
            if(this.$route.params.type == 'hot.html'){
                // 请求的type
                var type = ''
            } else {
                // 请求的type
                var type = '1000' + _this.search_index
            }
            $(window).bind("scroll", function() {
                if (on_off == 0 && _this.$publicObj.isScrollToPageBottom()) {
                    on_off = 1
                    //当滚动条到底时,触发内容
                    _this.page += 1
                    var data_info = _this.$publicObj.getSign('/baike/view/list', {
                        search: _this.search,
                        city: _this.$store.state.cookies.city || 103,
                        type: type,
                        page: _this.page,
                    }, _this.$store.state)
                    $.ajax({
                        url: 'https://japiv2.zuke.com/baike/view/list',
                        type: 'post',
                        data: data_info,
                        success: function(res) {
                            if(res.code == 10000){
                                for(var i = 0; i < res.data.length; i++){
                                    _this.arr.push(res.data[i]) 
                                }
                                on_off = 0
                            }
                        }
                    })
                }
            });
            // 查询历史记录
            var arr = JSON.parse(localStorage.getItem('history_arr'))
            if (!arr) {
                arr = []
            }
            if (search != '') {
                for (var i = 0; i < arr.length; i++) {
                    if (arr[i] == search) {
                        arr.splice(i, 1)
                    }
                }
                arr.unshift(search)
            }
            localStorage.setItem('history_arr', JSON.stringify(arr))
            // console.log(localStorage.getItem('history_arr'))
            this.history = arr
        },

        methods: {
            // 点击切换选项
            search_btn(num, name) {
                this.search_index = num
                this.type = this.typearr[num - 1]
                if(!this.search){
                    this.$router.push({
                        name:'baike_list',
                        params:{
                            type:this.type+'.html',
                        },
                    })
                } else {
                    this.$router.push({
                        name:'baike_list',
                        params:{
                            type:this.type+'.html',
                        },
                        query:{
                            search:this.search,
                        },
                    })
                }
            },
            // 判断是否填写了内容
            search_input() {
                if(!this.search){
                    this.$router.push({
                        name:'baike_list',
                        params:{
                            type:this.type+'.html',
                        },
                    })
                } else {
                    this.$router.push({
                        name:'baike_list',
                        params:{
                            type:this.type+'.html',
                        },
                        query:{
                            search:this.search,
                        },
                    })
                }
            }
        }
    }
</script>

<style scoped>
    .head_box {
        height: 3.669333rem;
    }

    .head_top_box {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 3.669333rem;
        z-index: 100;
    }

    .head_top {
        display: flex;
        align-items: center;
        width: 100%;
        min-width: 8rem;
        max-width: 16rem;
        margin: 0 auto;
        height: 1.877333rem;
        background-color: #fff;
    }

    .head_top>a {
        display: block;
        width: 2.133333rem;
        height: 1.877333rem;
    }

    .head_top a img {
        display: block;
        height: 1.28rem;
        margin: 0 auto;
        padding: 0.298666rem;
    }

    .head_top .seatch {
        display: flex;
        align-items: center;
        flex: 1;
        height: 1.28rem;
        background-color: #f9f9f9;
        margin-right: 1.002666rem;
        border-radius: 0.128rem;
    }

    .head_top .seatch input {
        display: block;
        flex: 1;
        height: 100%;
        margin-left: 0.426666rem;
        border: 0;
        background-color: #f9f9f9;
    }

    .head_top .seatch img {
        width: 0.704rem;
        height: 0.704rem;
        padding: 0.298666rem 0.426666rem;
    }

    .seatch_btn {
        display: flex;
        width: 100%;
        max-width: 16rem;
        min-width: 8rem;
        margin: 0 auto;
        height: 1.55rem;
        padding-top: 0.298666rem;
        overflow-x: scroll;
        background-color: #fff;
        border-bottom: 1px solid #ddd;
    }

    .seatch_btn::-webkit-scrollbar {
        display: none;
    }

    .seatch_btn .search_btn_list {
        flex-shrink: 0;
        height: 1.450666rem;
        line-height: 1.450666rem;
        margin: 0 0.746666rem;
        color: #333;
        font-size: 0.682666rem;
        padding: 0 0.277333rem;
        border-bottom: 1px solid rgba(0, 0, 0, 0);
    }

    .seatch_btn .search_btn_list.active {
        color: #3fabfa;
        border-bottom: 2px solid #3fabfa;
    }

    .seatch_btn .search_btn_list:last-child {
        margin-left: 0;
    }

    /* 搜索历史 */
    .history_box {
        position: relative;
        padding: 1.024rem 0.512rem 0;
    }

    .history_title {
        width: 100%;
        font-size: 0.554666rem;
        color: #666;
        font-weight: 500;
        margin-bottom: 0.426666rem;
    }

    .del_img {
        position: absolute;
        top: 0.896rem;
        right: 0.597333rem;
        width: 0.789333rem;
        height: 0.768rem;
    }

    .del_img img {
        width: 100%;
        height: 100%;
    }

    .history_list_box {
        width: 100%;
        display: flex;
    }

    .shistory_list {
        padding: 0.384rem;
        font-size: 0.597333rem;
        color: #333;
        background-color: #f3f5f7;
        border-radius: 0.213333rem;
        margin-left: 0.426666rem;
    }

    .shistory_list:first-child {
        margin-left: 0;
    }


    /* 列表 */
    .list {
        background-color: #F8F8F8;
        overflow: hidden;
    }

    .list_list {
        padding: 0.64rem 0 0;
        background-color: #fff;
        margin-bottom: 0.682666rem;
    }

    .list_list:last-child {
        margin-bottom: 0;
    }

    .list_list a {
        display: flex;
        flex-wrap: wrap;
    }

    .list_img {
        width: 3.370666rem;
        height: 3.370666rem;
        margin-right: 0.64rem;
        margin-left: 0.512rem;
        vertical-align: top;
    }

    .list_img img {
        width: 3.370666rem;
        height: 3.370666rem;
    }

    .list_box {
        flex: 1;
        margin-right: 0.512rem;
        width: 200px;
    }

    .list_box .list_title {
        display: block;
        font-size: 0.768rem;
        color: #333;
        font-weight: 500;
        margin-bottom: 0.426666rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .list_box .list_i {
        display: flex;
        /* align-items: center; */
    }

    .list_box .list_i_list {
        flex: 1;
        text-align: center;
        padding: 0.128rem 0;
    }

    .list_box .list_i .list_i_list:first-child {
        border-right: 1px solid #eee;
    }

    .list_box .list_i_title {
        font-size: 0.554666rem;
        color: #999;
        margin-bottom: 0.213333rem;
    }

    .list_box .list_i_text {
        font-size: 0.554666rem;
        color: #333;
    }

    .list_bot {
        display: flex;
        width: 100%;
        border-top: 1px solid #eee;
        padding: 0.426666rem 0.512rem;
    }

    .list_bot img {
        height: 0.725333rem;
    }

    .list_bot .list_bot_title {
        vertical-align: top;
        font-size: 0.554666rem;
        color: #333;
        margin-left: 0.298666rem;
    }

    .hot_xq_bot {
        display: flex;
        width: 100%;
        border-top: 1px solid #eee;
        padding: 0.426666rem 0.512rem;
        margin-top: 0.853333rem;
        overflow: hidden;
    }

    .hot_xq_bot img {
        height: 0.725333rem;
    }

    .hot_xq_bot .hot_xq_bot_title {
        vertical-align: top;
        font-size: 0.554666rem;
        color: #333;
        margin-left: 0.298666rem;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    
    .list_no_data {
        display: block;
        max-width: calc(100% - 5.12rem);
        padding: 2.56rem;
        background-color: #fff;
    }
    
</style>



// WEBPACK FOOTER //
// baike_list.vue